class measureHelper {
    constructor() {
        if (!measureHelper.instance) {
            measureHelper.instance = this;
            measureHelper.instance._lengthMultiplier = 1;
            measureHelper.instance._areaMultiplier = 1;
            measureHelper.instance.formatLength = this._formatLengthMetric;
            measureHelper.instance.formatArea = this._formatAreaMetric;
        }

        return measureHelper.instance;
    }

    initUnits(unitType) {
        switch (unitType.toLowerCase()) {
            case 'miles':
                this._lengthMultiplier = 0.00062137;
                this.formatLength = this._formatLengthMetricMile;
                this._areaMultiplier = 0.0000003861;
                this.formatArea = this._formatAreaMetric;
                break;
            case 'metric':
                this._lengthMultiplier = 1;
                this.formatLength = this._formatLengthMetric;
                this._areaMultiplier = 1;
                this.formatArea = this._formatAreaMetric;
                this.formatVolume = this._formatAreaVolume;
                this.formatFacede = this._formatAreaFacade;
                break;
            case 'imperial':
                this._lengthMultiplier = 3.28084;
                this.formatLength = this._formatLengthImperial;
                this._areaMultiplier = 10.7639;
                this.formatArea = this._formatAreaImperial;
                break;
            case 'nautical':
                this._lengthMultiplier = 1;
                this.formatLength = this._formatLengthNautical;
                this._areaMultiplier = 1;
                this.formatArea = this._formatAreaMetric;
                break;
            default:
                this._lengthMultiplier = 1;
                this.formatLength = this._formatLengthMetric;
                this._areaMultiplier = 1;
                this.formatArea = this._formatAreaMetric;
                break;
        }
    }

    _formatLengthMetric(value) {
        let unit;
        if (value / 1000 >= 1) {
            unit = 'km';
            value /= 1000;
        } else {
            unit = 'm';
        }
        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _formatLengthMetricMile(value) {
        let unit = 'mile';
        value = value * 0.00062137;

        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _formatLengthImperial(value) {
        let unit;
        if (value / 5280 >= 1) {
            unit = 'mi';
            value /= 5280;
        } else {
            unit = 'ft';
        }
        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _formatLengthNautical(value) {
        let unit = 'NM';
        value /= 1852;
        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _formatAreaMetric(value) {
        let unit;
        if (value / 1000000 >= 1) {
            unit = 'km²';
            value /= 1000000;
        } else {
            unit = 'm²';
        }
        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _formatAreaImperial(value) {
        let unit;
        if (value * 3.587e-8 >= 1) {
            unit = 'mi²';
            value *= 3.587e-8;
        } else {
            unit = 'ft²';
        }
        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _formatAreaVolume(value) {
        let unit;
        if (value / 1000000000 >= 1) {
            unit = 'km³';
            value /= 1000000000;
        } else {
            unit = 'm³';
        }
        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _formatAreaFacade(value) {
        let unit;
        if (value / 1000000 >= 1) {
            unit = 'km²';
            value /= 1000000;
        } else {
            unit = 'm²';
        }
        return this._numberToLocale(this._roundUp(value, 2)) + ' ' + unit;
    }

    _roundUp(value, decimals) {
        return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
    }

    _numberToLocale(number) {
        return new Intl.NumberFormat().format(number);
    }
}

export default measureHelper;
